import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { getI18n, useTranslation } from 'react-i18next';
import { languageOptionsMap, Languages } from '../model/types';
import { changeLanguageOnLocalStorage } from '../utils/i18n';

function handleChangeLanguage(language: Languages) {
    changeLanguageOnLocalStorage(language);
    getI18n().changeLanguage(language);
}

const LanguageDropdown = (): JSX.Element => {
    const {
        t,
        i18n: { language }
    } = useTranslation('forms');

    const items = Object.keys(languageOptionsMap).map((key: Languages) => ({
        key,
        label: t(key as any),
        value: key,
        onClick: () => handleChangeLanguage(key)
    }));

    return (
        <Dropdown menu={{ items, selectedKeys: [language] }} trigger={['click']}>
            <Button>
                {t(language as any)} <DownOutlined />
            </Button>
        </Dropdown>
    );
};

export default LanguageDropdown;
